import styled from 'styled-components'
import Flex from '../../Layout/Flex/Flex'
import { PopupBoxProps } from './types'

export const PopupContainer = styled(Flex)<{popupContainerWidth?: string, popupContainerHeight?: string}>`
  z-index: 101;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  width: ${props => props.popupContainerWidth || '100vw' };
  height: ${props => props.popupContainerHeight || '100vh' };
`

// eslint-disable-next-line
export const PopupBox = styled(Flex)<PopupBoxProps | any>`
  min-width: 50vw;
  max-width: 80vw;
  background-color: ${props =>  props.theme.colors?.light?.[props.type]};
  box-shadow: 0px 8px 10px #0000001A;
  border-radius: 4px;
`

export const IconWrapper = styled(Flex)`
  margin: 8px;
  padding: 8px;
`

export const LabelWrapper = styled.div`
  width: 100%;
  margin: 16px;
  padding: 8px;
`
